/**
 * Типа действия карточек акций
 *
 * @name Store.ActionTypes.promo.ActionTypesPromo
 * @type {Record<string, string>}
 */
export const ActionTypesPromo = {
    SET_CATEGORY_PROMO_CARD: 'SET_CATEGORY_PROMO_CARD',
};
